var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51672 19.8998C5.12445 19.9226 4.73866 19.7922 4.44071 19.5361C3.8531 18.945 3.8531 17.9903 4.44071 17.3992L17.3075 4.53227C17.9187 3.96038 18.8777 3.99217 19.4496 4.60334C19.9668 5.15602 19.9969 6.0055 19.5202 6.59342L6.57756 19.5361C6.28346 19.7885 5.90386 19.9187 5.51672 19.8998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3684 19.8998C17.9708 19.8981 17.5898 19.7403 17.3075 19.4603L4.44059 6.59337C3.89619 5.95765 3.97021 5.00091 4.60593 4.45647C5.17334 3.97057 6.01014 3.97057 6.57749 4.45647L19.5201 17.3234C20.1312 17.8954 20.1628 18.8545 19.5907 19.4655C19.568 19.4898 19.5444 19.5133 19.5201 19.5361C19.2032 19.8117 18.7861 19.9434 18.3684 19.8998Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.254a653a59c87e9b996cfb8ae5ef117e.svg";
export { ForwardRef as ReactComponent };